'use client';

import { createContext, useContext } from 'react';
import type React from 'react';

export type ComponentRegistry = Record<string, React.FC<any>>;

const ComponentRegistryContext = createContext<ComponentRegistry | null>(null);

export const ComponentRegistryProvider = ComponentRegistryContext.Provider;

/**
 * Access the component registry from anywhere in the form-renderer tree.
 * Used by wrapper components (e.g. `SubFormDialog`, `NestedForm`, `KeyPersons`,
 * `RoleAssignment`) that need to hand the registry to `LinkedFormRenderer`
 * without importing it from `useFormRenderer.tsx` (which would create a cycle).
 */
export function useComponentRegistry(): ComponentRegistry {
  const registry = useContext(ComponentRegistryContext);
  if (!registry) {
    throw new Error(
      'useComponentRegistry must be used inside a ComponentRegistryProvider'
    );
  }
  return registry;
}
